var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI07QuestionFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 3.0375H8.75C5 3.0375 2.5 5.5375 2.5 9.2875V16.7875C2.5 20.5375 5 23.0375 8.75 23.0375V25.7C8.75 26.7 9.8625 27.3 10.6875 26.7375L16.25 23.0375H21.25C25 23.0375 27.5 20.5375 27.5 16.7875V9.2875C27.5 5.5375 25 3.0375 21.25 3.0375ZM15 18.25C14.475 18.25 14.0625 17.825 14.0625 17.3125C14.0625 16.8 14.475 16.375 15 16.375C15.525 16.375 15.9375 16.8 15.9375 17.3125C15.9375 17.825 15.525 18.25 15 18.25ZM16.575 13.0625C16.0875 13.3875 15.9375 13.6 15.9375 13.95V14.2125C15.9375 14.725 15.5125 15.15 15 15.15C14.4875 15.15 14.0625 14.725 14.0625 14.2125V13.95C14.0625 12.5 15.125 11.7875 15.525 11.5125C15.9875 11.2 16.1375 10.9875 16.1375 10.6625C16.1375 10.0375 15.625 9.525 15 9.525C14.375 9.525 13.8625 10.0375 13.8625 10.6625C13.8625 11.175 13.4375 11.6 12.925 11.6C12.4125 11.6 11.9875 11.175 11.9875 10.6625C11.9875 9 13.3375 7.65 15 7.65C16.6625 7.65 18.0125 9 18.0125 10.6625C18.0125 12.0875 16.9625 12.8 16.575 13.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI07QuestionFull);
export default __webpack_public_path__ + "static/media/I07-question_full.c22878052dc01d780ddfebf613153638.svg";
export { ForwardRef as ReactComponent };